<hive-content-dialog
    #copilotOnboardingModalDialog
    size="medium"
    [showCloseButton]="true"
    (contentDialogClose)="dismissModalDialog()"
    heading="Welcome to Pure Storage AI Copilot!"
>
    <!-- use a specific class selector since this will be created in the DOM outside of the component -->
    <div class="copilot-onboarding-modal-dialog-content">
        <img src="/images/ai-onboarding-background.jpg" class="dialog-background-img" />

        <div class="dialog-description-container">
            <div class="dialog-description-text">
                <span class="hive-paragraph-small hive-paragraph-regular">
                    <strong>Meet Pure Storage AI Copilot</strong>
                    - your new productivity partner, knowledge base assistant, troubleshooting companion & commerce
                    guide - always ready and available to help you!
                </span>

                <span class="hive-paragraph-small hive-paragraph-regular">
                    <strong>Feedback Ownership:</strong>
                    By using this service, you agree that all feedback, suggestions, and other input you provide
                    regarding this feature belongs to Pure Storage, which reserves the right to use this feedback for
                    any purpose without any obligation to you.
                </span>

                <span class="hive-paragraph-small hive-paragraph-regular">
                    <strong>No Warranty:</strong>
                    The Copilot is based on Generative AI technologies, which is still experimental. It is provided “as
                    is,” and Pure makes no warranties, express or implied, regarding its performance or reliability.
                </span>

                <!--
                    Note: Last minute decision was made to remove this for now, so just leaving it commented out.
                <span class="hive-paragraph-small hive-paragraph-regular checkbox-container">
                    <hive-checkbox [(checked)]="optInChecked" size="small">
                        I'd like to join the Early Adopter Program to access new beta features as they become available.
                        <i>(Optional)</i>
                    </hive-checkbox>
                </span>
                -->

                <div class="disclaimer-container">
                    <div
                        >If you would like to have your organization opted out of the Copilot, please file a support
                        ticket.</div
                    >
                    <div
                        >Generative AI is experimental and by using AI Copilot, you agree to the legal terms &amp;
                        conditions.</div
                    >

                    <a
                        hive-link
                        [external]="true"
                        href="https://support.purestorage.com/bundle/m_ai_copilot/page/Pure1/Pure1_Manage/topics/c_aicopilot_user_guide.html"
                        >Copilot FAQs</a
                    >
                    <a hive-link [external]="true" href="https://pure1.purestorage.com/support"
                        >File a support ticket</a
                    >
                    <a hive-link [external]="true" href="https://www.purestorage.com/legal/pure-end-user-agreement.html"
                        >Legal terms &amp; conditions</a
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- use a specific class selector since this will be created in the DOM outside of the component -->
    <div class="copilot-onboarding-modal-dialog-actions-container" slot="actions-right">
        <hive-button emphasis="secondary" label="Maybe Later" (click)="dismissModalDialog()"> </hive-button>
        <hive-button
            emphasis="primary"
            label="Try AI Copilot™"
            (click)="ackOnboardingModal()"
            [disabled]="!optInChecked"
        >
        </hive-button>
    </div>
</hive-content-dialog>
